import React from 'react'

const TermsConditions = () => {
  return (
    <div className='min-h-screen flex flex-col bg-background'>
      <main className='flex-grow container mx-auto px-4 py-8'>
        <h1 className='text-3xl font-bold text-text-primary mb-6'>
          Términos y Condiciones de Uso
        </h1>

        <div className='bg-card p-6 rounded-lg shadow-sm'>
          <p className='text-text-secondary mb-4'>
            Última actualización: 23 de marzo de 2025
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            1. Información General
          </h2>
          <p className='text-text-secondary mb-4'>
            Bienvenido a Conversor IAE CNAE ("el Sitio", "nosotros", "nuestro"),
            un servicio en línea que proporciona herramientas de conversión
            entre códigos IAE (Impuesto de Actividades Económicas) y CNAE
            (Clasificación Nacional de Actividades Económicas) para autónomos y
            empresas en España.
          </p>
          <p className='text-text-secondary mb-4'>
            El acceso y uso de este sitio web están sujetos a los siguientes
            términos y condiciones, así como a todas las leyes aplicables. Al
            acceder y utilizar el Sitio, confirmas que has leído, entendido y
            aceptado los siguientes términos y condiciones.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            2. Uso del Servicio
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            2.1 Propósito del Servicio
          </h3>
          <p className='text-text-secondary mb-4'>
            El Sitio está diseñado para facilitar la búsqueda y conversión de
            códigos de actividades económicas (IAE a CNAE y viceversa) con fines
            informativos y orientativos.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            2.2 Uso Permitido
          </h3>
          <p className='text-text-secondary mb-4'>
            Puedes utilizar el Sitio para:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>Buscar códigos IAE o CNAE</li>
            <li className='mb-2'>Convertir códigos IAE a CNAE y viceversa</li>
            <li className='mb-2'>
              Consultar información sobre códigos específicos
            </li>
            <li className='mb-2'>
              Acceder a los directorios de códigos disponibles
            </li>
            <li className='mb-2'>Suscribirte a nuestra newsletter</li>
          </ul>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            2.3 Restricciones de Uso
          </h3>
          <p className='text-text-secondary mb-4'>Te comprometes a no:</p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>
              Utilizar el Sitio de manera que pueda dañar, deshabilitar,
              sobrecargar o deteriorar el servidor
            </li>
            <li className='mb-2'>
              Intentar acceder sin autorización a áreas restringidas del Sitio
            </li>
            <li className='mb-2'>
              Utilizar dispositivos automáticos o manuales para rastrear
              ("scrape") información del Sitio
            </li>
            <li className='mb-2'>
              Reproducir, duplicar, copiar, vender, revender o explotar
              cualquier parte del Sitio sin autorización expresa
            </li>
          </ul>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            3. Exención de Responsabilidad
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            3.1 Carácter Orientativo
          </h3>
          <p className='text-text-secondary mb-4'>
            Toda la información proporcionada en el Sitio es meramente
            orientativa, aunque ha sido cuidadosamente extraída de fuentes
            oficiales como el Instituto Nacional de Estadística (INE) y la
            Agencia Tributaria española.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            3.2 No Constituye Asesoramiento Profesional
          </h3>
          <p className='text-text-secondary mb-4'>
            El contenido del Sitio en ningún caso constituye asesoramiento
            legal, fiscal, financiero o profesional de cualquier tipo.
            Recomendamos encarecidamente consultar con un asesor fiscal o legal
            cualificado antes de tomar decisiones basadas en la información
            proporcionada.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            3.3 Limitación de Responsabilidad
          </h3>
          <p className='text-text-secondary mb-4'>
            No nos hacemos responsables de:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>Errores u omisiones en el contenido</li>
            <li className='mb-2'>
              Cualquier pérdida o daño que pueda derivarse del uso de la
              información proporcionada
            </li>
            <li className='mb-2'>
              Decisiones tomadas basándose únicamente en la información del
              Sitio
            </li>
            <li className='mb-2'>
              Interrupciones o fallos técnicos que puedan afectar al servicio
            </li>
          </ul>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            4. Privacidad y Protección de Datos
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            4.1 Recopilación de Datos
          </h3>
          <p className='text-text-secondary mb-4'>
            Recopilamos información personal limitada, principalmente
            direcciones de correo electrónico para nuestra newsletter. Para más
            detalles, consulta nuestra Política de Privacidad.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            4.2 Protección de Datos
          </h3>
          <p className='text-text-secondary mb-4'>
            Protegemos tu privacidad y no compartimos tus datos con terceros.
            Cumplimos con todas las normativas de protección de datos
            aplicables, incluido el Reglamento General de Protección de Datos
            (RGPD).
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            4.3 Cookies
          </h3>
          <p className='text-text-secondary mb-4'>
            El Sitio puede utilizar cookies para mejorar la experiencia del
            usuario. Puedes configurar tu navegador para rechazar cookies,
            aunque esto puede afectar a la funcionalidad del Sitio.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            5. Propiedad Intelectual
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            5.1 Derechos de Autor
          </h3>
          <p className='text-text-secondary mb-4'>
            Todo el contenido del Sitio, incluyendo pero no limitado a textos,
            gráficos, logotipos, iconos, imágenes, clips de audio, descargas
            digitales y compilaciones de datos, es propiedad de Conversor IAE
            CNAE o de sus proveedores de contenido y está protegido por las
            leyes de propiedad intelectual españolas e internacionales.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            5.2 Uso del Contenido
          </h3>
          <p className='text-text-secondary mb-4'>
            No está permitida la reproducción, distribución, modificación,
            exhibición pública o creación de obras derivadas del contenido del
            Sitio sin autorización expresa por escrito.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            6. Enlaces a Terceros
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            6.1 Enlaces Externos
          </h3>
          <p className='text-text-secondary mb-4'>
            El Sitio puede contener enlaces a sitios web de terceros, incluyendo
            nuestra comunidad en Reddit. Estos enlaces se proporcionan
            únicamente para tu conveniencia.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            6.2 No Responsabilidad
          </h3>
          <p className='text-text-secondary mb-4'>
            No tenemos control sobre el contenido de sitios web de terceros y no
            asumimos responsabilidad por su contenido o prácticas de privacidad.
            El acceso a cualquier otro sitio web vinculado es bajo tu propio
            riesgo.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            7. Modificaciones
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            7.1 Cambios en los Términos
          </h3>
          <p className='text-text-secondary mb-4'>
            Nos reservamos el derecho de modificar estos términos y condiciones
            en cualquier momento. Los cambios serán efectivos inmediatamente
            después de su publicación en el Sitio.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            7.2 Cambios en el Servicio
          </h3>
          <p className='text-text-secondary mb-4'>
            Nos reservamos el derecho de modificar, suspender o interrumpir
            cualquier aspecto del Sitio en cualquier momento sin previo aviso.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            8. Ley Aplicable y Jurisdicción
          </h2>
          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            8.1 Legislación Española
          </h3>
          <p className='text-text-secondary mb-4'>
            Estos términos y condiciones se rigen e interpretan de acuerdo con
            las leyes españolas.
          </p>

          <h3 className='text-lg font-semibold text-text-primary mb-3'>
            8.2 Resolución de Conflictos
          </h3>
          <p className='text-text-secondary mb-4'>
            Cualquier disputa relacionada con estos términos será resuelta
            exclusivamente por los tribunales competentes de España.
          </p>

          <h2 className='text-xl font-semibold text-text-primary mb-4 mt-6'>
            9. Contacto
          </h2>
          <p className='text-text-secondary mb-4'>
            Si tienes alguna pregunta sobre estos Términos y Condiciones, puedes
            contactarnos en:
          </p>
          <ul className='list-disc pl-6 text-text-secondary mb-4'>
            <li className='mb-2'>
              <strong>Email:</strong> contacto@conversoriaecnae.es
            </li>
            <li className='mb-2'>
              <strong>Comunidad:</strong>{' '}
              <a
                href='https://www.reddit.com/r/ConversorIAE_CNAE/'
                className='text-primary hover:underline'
              >
                https://www.reddit.com/r/ConversorIAE_CNAE/
              </a>
            </li>
          </ul>
          <p className='text-text-secondary mb-4'>
            Al utilizar nuestro Sitio, confirmas que has leído, entendido y
            aceptado estos Términos y Condiciones en su totalidad.
          </p>
        </div>
      </main>
    </div>
  )
}

export default TermsConditions
